import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const NavigationBarMusicIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 20 20"
    sx={{ width: '20px', height: '20px', ...sx }}
    {...props}
  >
    <path
      d="M18.04 1.87a.83.83 0 0 0-.66-.2L6.54 3.34a.83.83 0 0 0-.7.83v8.62a2.88 2.88 0 0 0-2.88.2 2.92 2.92 0 1 0 4.54 2.43V9.05l9.17-1.4v3.47a2.88 2.88 0 0 0-2.87.2 2.92 2.92 0 1 0 4.53 2.43V2.5a.83.83 0 0 0-.29-.63ZM4.58 16.67a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5ZM15.42 15a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Zm1.25-9.05L7.5 7.35v-2.5l9.17-1.37v2.47Z"
      fill="#5C64ED"
    />
    <path
      d="M18.04 1.87a.83.83 0 0 0-.66-.2L6.54 3.34a.83.83 0 0 0-.7.83v8.62a2.88 2.88 0 0 0-2.88.2 2.92 2.92 0 1 0 4.54 2.43V9.05l9.17-1.4v3.47a2.88 2.88 0 0 0-2.87.2 2.92 2.92 0 1 0 4.53 2.43V2.5a.83.83 0 0 0-.29-.63ZM4.58 16.67a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5ZM15.42 15a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Zm1.25-9.05L7.5 7.35v-2.5l9.17-1.37v2.47Z"
      fill="url(#a)"
    />
    <defs>
      <linearGradient
        id="a"
        x1="10"
        y1="1.67"
        x2="10"
        y2="18.33"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9445EC" />
        <stop offset="1" stopColor="#2782ED" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

NavigationBarMusicIcon.defaultProps = {
  sx: null,
}
